<template>
  <el-select v-model="season" placeholder="选择季度">
    <el-option
      v-for="(item, key) in seasons"
      :key="key"
      :label="item.label"
      :value="item.label"
    >
    </el-option>
  </el-select>
</template>

<script>
import { seasons } from "../utils/utilData";

export default {
  name: "SeasonGroup",
  data() {
    return {
      seasons: [],
      season: "",
    };
  },

  watch: {
    season(newVal, oldVal) {
      this.$emit("season", this.season);
    },
  },
  created() {
    this.seasons = seasons;
  },
};
</script>

<style scoped lang="scss">
</style>